import _ from 'lodash';

import { getClosestNumberInArray } from 'bundles/common/utils/commonUtils';

const CONFIG = {
  defaultType: 'video/mp4',
  defaultRes: 720,
};

/**
 * A model class to generalize the data layer for VideoPlayer
 * Currently handle onDemandVideosV1 & assetsV1
 * The main API includes: get srcArray, src, poster, and the default player settings
 */
class VideoPlayerModel {
  constructor({ onDemandVideos, videoAsset }: $TSFixMe) {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
    this._srcArray = [];
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_src' does not exist on type 'VideoPlaye... Remove this comment to see the full error message
    this._src = null;
    if (onDemandVideos) {
      this.setOnDemandVideos(onDemandVideos);
    }
    if (videoAsset) {
      this.setVideoAsset(videoAsset);
    }
  }

  get srcArray() {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
    return this._srcArray;
  }

  get src() {
    return this.getSrc();
  }

  get poster() {
    return this.getPoster();
  }

  getSrc() {
    // @ts-expect-error ts-migrate(2551) FIXME: Property '_src' does not exist on type 'VideoPlaye... Remove this comment to see the full error message
    let src = this._src;
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_hasMultiRes' does not exist on type 'Vi... Remove this comment to see the full error message
    if (!src && this._hasMultiRes) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      const firstSrc = _.first(this._srcArray);

      if (firstSrc) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'src' does not exist on type 'unknown'.
        const { src: updatedSrc } = firstSrc;
        src = updatedSrc;
      }
    }
    return src;
  }

  getPoster() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_hasMultiRes' does not exist on type 'Vi... Remove this comment to see the full error message
    if (this._hasMultiRes) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      return _.first(this._srcArray).poster;
    }
    return undefined;
  }

  getRes() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_hasMultiRes' does not exist on type 'Vi... Remove this comment to see the full error message
    if (this._hasMultiRes) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      const allResolutionsSorted = VideoPlayerModel.getAllResSorted(this._srcArray);
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_wrapperWidth' does not exist on type 'V... Remove this comment to see the full error message
      if (!this._wrapperWidth) {
        return _.last(allResolutionsSorted);
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property '_wrapperWidth' does not exist on type 'V... Remove this comment to see the full error message
        return getClosestNumberInArray(this._wrapperWidth, allResolutionsSorted);
      }
    }

    return CONFIG.defaultRes;
  }

  getResByWrapperWidth(wrapperWidth: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_wrapperWidth' does not exist on type 'V... Remove this comment to see the full error message
    this._wrapperWidth = wrapperWidth;
    return this.getRes();
  }

  static getAllResSorted(srcArray: $TSFixMe) {
    return _.uniq(_.sortBy(_.map(srcArray, 'res')));
  }

  getDefaultPlayerSettingByWrapperWidth(wrapperWidth: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_wrapperWidth' does not exist on type 'V... Remove this comment to see the full error message
    this._wrapperWidth = wrapperWidth;
    let src = this.getSrc();
    let poster = this.getPoster();
    const res = this.getRes();
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_hasMultiRes' does not exist on type 'Vi... Remove this comment to see the full error message
    if (wrapperWidth && this._hasMultiRes) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      const defaultSrc = _.find(this._srcArray, (item) => item.type === CONFIG.defaultType && item.res === res);

      if (defaultSrc !== -1) {
        const { src: updatedSrc, poster: updatedPoster } = defaultSrc;
        src = updatedSrc;
        poster = updatedPoster;
      }
    }

    return {
      res,
      src,
      poster,
      type: CONFIG.defaultType,
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      srcArray: this._srcArray,
    };
  }

  static getByResolution(onDemandVideosNaptime: $TSFixMe) {
    if (onDemandVideosNaptime && onDemandVideosNaptime.sources && onDemandVideosNaptime.sources.byResolution) {
      return onDemandVideosNaptime.sources.byResolution;
    }
    return undefined;
  }

  setOnDemandVideos(onDemandVideosNaptime: $TSFixMe) {
    const byResolution = VideoPlayerModel.getByResolution(onDemandVideosNaptime);
    if (!_.isEmpty(byResolution)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_hasMultiRes' does not exist on type 'Vi... Remove this comment to see the full error message
      this._hasMultiRes = true;
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      this._srcArray = VideoPlayerModel.convertOnDemandVideosToSources(byResolution);
    }
  }

  setVideoAsset(videoAsset: $TSFixMe) {
    const { videoSourceUrls } = videoAsset;
    if (!_.isEmpty(videoSourceUrls)) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property '_srcArray' does not exist on type 'Video... Remove this comment to see the full error message
      this._srcArray = VideoPlayerModel.convertVideoAssetToSources(videoAsset);
    }
  }

  static convertOnDemandVideosToSources(byResolution: $TSFixMe) {
    const byResolutionNoTypes = _.omit(byResolution, '__typename');
    return _.reduce(
      byResolutionNoTypes,
      (total, item, resLabel) => {
        const res = parseInt(resLabel, 10);
        const poster = item.previewImageUrl;
        // @ts-expect-error TSMIGRATION-4.8 TS2345
        total.push({
          type: 'video/webm',
          src: item.webMVideoUrl,
          label: resLabel,
          res,
          poster,
        });

        // @ts-expect-error TSMIGRATION-4.8 TS2345
        total.push({
          type: 'video/mp4',
          src: item.mp4VideoUrl,
          label: resLabel,
          res,
          poster,
        });
        return total;
      },
      []
    );
  }

  static convertVideoAssetToSources(videoAsset: $TSFixMe) {
    return _.reduce(
      videoAsset.videoSourceUrls,
      (total, item, resLabel) => {
        const res = parseInt(resLabel, 10);
        const thumbnail = videoAsset.videoThumbnailUrls && _.first(videoAsset.videoThumbnailUrls[resLabel]);
        // @ts-expect-error TSMIGRATION-4.8 TS2345
        total.push({
          type: 'video/webm',
          src: item['video/webm'].url,
          label: resLabel,
          res,
          poster: thumbnail && thumbnail.url,
        });

        // @ts-expect-error TSMIGRATION-4.8 TS2345
        total.push({
          type: 'video/mp4',
          src: item['video/mp4'].url,
          label: resLabel,
          res,
          poster: thumbnail && thumbnail.url,
        });
        return total;
      },
      []
    );
  }
}

export default VideoPlayerModel;
